import React from 'react';

import { componentKey, validate } from 'src/utils/EntryUtil';
import { IEntriesProps, IEntryProp } from '../IEntries';

interface IRepeaterProps extends IEntriesProps {
  component: React.ComponentType<IEntryProp>;
}

export const ItemRepeater: React.FC<IRepeaterProps> = ({
  component, entries = [], children, ...props
}) => (
  <>
    {entries.map((entry, index) => validate(entry) && React.createElement(
      component,
      { key: componentKey(entry, index), entry, first: index === 0, ...props },
      children
    ))}
  </>
);
